import { useEffect, useRef } from "react";

const RGB = { pokemon: "255,68,56", riftbound: "59,130,246", yugioh: "139,92,246" };
const SP = 0.5;
const FRONT_MS = 1200;
const FX_MASK = "linear-gradient(to bottom, transparent 0, #000 14%, #000 88%, transparent 100%)";
const CANVAS_CLS = "pointer-events-none absolute -top-10 -bottom-8 -left-4 -right-4 lg:left-0 lg:right-0 w-[calc(100%+2rem)] lg:w-full h-[calc(100%+4.5rem)]";

function bolt(x1, y1, x2, y2, d) {
  let pts = [[x1, y1], [x2, y2]];
  let off = Math.hypot(x2 - x1, y2 - y1) * .22;
  for (let g = 0; g < 5; g++) {
    const np = [];
    for (let i = 0; i < pts.length - 1; i++) {
      const [ax, ay] = pts[i], [bx, by] = pts[i + 1];
      np.push([ax, ay], [(ax + bx) / 2 + (Math.random() - .5) * off, (ay + by) / 2 + (Math.random() - .5) * off]);
    }
    np.push(pts[pts.length - 1]); pts = np; off /= 2;
  }
  const br = [];
  if (d < 1) for (let i = 0; i < 2; i++) { const p = pts[Math.floor(pts.length * (.3 + Math.random() * .5))]; br.push(bolt(p[0], p[1], p[0] + (Math.random() - .5) * 120, p[1] + (Math.random() - .3) * 90, d + 1)); }
  return { pts, br, life: 0, max: 9 + Math.random() * 8 };
}

function step(p, s, sp) {
  if (p.t === "ember") { p.vx += Math.sin(p.life * .08 + p.y * .02) * .03; p.vy = p.amb ? p.vy : p.vy * .96 - .05; p.x += p.vx * sp; p.y += p.vy * sp; }
  else if (p.t === "spark") { p.x += p.vx * sp; p.y += p.vy * sp; p.vx *= .93; p.vy *= .93; }
  else if (p.t === "drop") { p.vy += .12 * sp; p.vx *= .98; p.x += p.vx * sp; p.y += p.vy * sp; }
  else if (p.t === "bub") {
    p.y += p.vy * sp; p.x += Math.sin(p.life * .05 + p.wob) * .4 * sp;
    if (p.life >= p.max - sp) s.p.push({ t: "ring", x: p.x, y: p.y, r: p.r, life: 0, max: 14, fr: p.fr });
  }
}

function draw(x, p) {
  const q = p.life / p.max;
  if (p.t === "ember") {
    const col = q < .25 ? "255,236,170" : q < .6 ? "255,150,70" : "255,68,56";
    const a = (1 - q) * (.6 + .4 * Math.random());
    x.fillStyle = "rgba(" + col + "," + (a * .25) + ")"; x.beginPath(); x.arc(p.x, p.y, p.r * 3.2, 0, 6.283); x.fill();
    x.fillStyle = "rgba(" + col + "," + a + ")"; x.beginPath(); x.arc(p.x, p.y, p.r, 0, 6.283); x.fill();
  } else if (p.t === "spark") {
    x.strokeStyle = "rgba(191,219,254," + (1 - q) + ")"; x.lineWidth = 1.4; x.beginPath(); x.moveTo(p.x, p.y); x.lineTo(p.x - p.vx * 3, p.y - p.vy * 3); x.stroke();
  } else if (p.t === "drop") {
    x.fillStyle = "rgba(167,139,250," + (1 - q) * .9 + ")"; x.beginPath(); x.ellipse(p.x, p.y, p.r * .8, p.r * 1.3, 0, 0, 6.283); x.fill();
  } else if (p.t === "bub") {
    const a = Math.min(1, (1 - q) * 3) * Math.min(1, p.life / 15);
    x.strokeStyle = "rgba(196,181,253," + (.7 * a) + ")"; x.fillStyle = "rgba(139,92,246," + (.14 * a) + ")"; x.lineWidth = 1.2;
    x.beginPath(); x.arc(p.x, p.y, p.r, 0, 6.283); x.fill(); x.stroke();
    x.fillStyle = "rgba(255,255,255," + (.6 * a) + ")"; x.beginPath(); x.arc(p.x - p.r * .35, p.y - p.r * .35, p.r * .22, 0, 6.283); x.fill();
  } else if (p.t === "ring") {
    x.strokeStyle = "rgba(196,181,253," + (1 - q) * .8 + ")"; x.lineWidth = 1; x.beginPath(); x.arc(p.x, p.y, p.r + q * 10, 0, 6.283); x.stroke();
  }
}

function drawBolt(x, b, lw) {
  const a = (1 - b.life / b.max) * (Math.random() < .25 ? .35 : 1);
  x.beginPath(); b.pts.forEach((p, i) => (i ? x.lineTo(p[0], p[1]) : x.moveTo(p[0], p[1])));
  x.strokeStyle = "rgba(59,130,246," + (.45 * a) + ")"; x.lineWidth = lw * 4; x.stroke();
  x.strokeStyle = "rgba(219,234,254," + a + ")"; x.lineWidth = lw; x.stroke();
  b.br.forEach((c2) => { c2.life = b.life; c2.max = b.max; drawBolt(x, c2, lw * .6); });
}

// Ambiente (canvas trasero) + ráfaga (canvas frontal ~1,2 s) por juego. Solo visual.
export const HitGameFx = ({ game, burstFrom }) => {
  const backRef = useRef(null);
  const frontRef = useRef(null);
  const gameRef = useRef(game);
  const sysRef = useRef(null);
  const reduce = typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

  useEffect(() => {
    if (reduce) { return undefined; }
    const c = backRef.current, cf = frontRef.current;
    const lowEnd = (navigator.hardwareConcurrency || 8) <= 4 && window.matchMedia?.("(pointer: coarse)").matches;
    const s = { ctx: c.getContext("2d"), fctx: cf.getContext("2d"), p: [], b: [], flash: 0, fx: 0, fy: 0, w: 0, h: 0, dpr: 1, burstAt: -1e9,
      k: lowEnd ? .6 : 1, maxP: lowEnd ? 250 : 600, mist: Array.from({ length: 5 }, (_, i) => ({ s: i * 1.7 })) };
    sysRef.current = s;
    let raf = 0, visible = true;
    const resize = () => {
      s.w = c.offsetWidth; s.h = c.offsetHeight; s.dpr = Math.min(2, window.devicePixelRatio || 1);
      [c, cf].forEach((el) => { el.width = Math.round(s.w * s.dpr); el.height = Math.round(s.h * s.dpr); });
    };
    resize();
    const ro = new ResizeObserver(resize); ro.observe(c);
    const loop = (now) => {
      raf = requestAnimationFrame(loop);
      const g = gameRef.current, k = s.k, sp = SP, t = now / 1000 * sp, w = s.w, h = s.h, x = s.ctx, fx = s.fctx, rgb = RGB[g];
      const fa = Math.max(0, 1 - (performance.now() - s.burstAt) / FRONT_MS);
      [x, fx].forEach((cx) => { cx.setTransform(s.dpr, 0, 0, s.dpr, 0, 0); cx.clearRect(0, 0, w, h); cx.globalCompositeOperation = "lighter"; cx.lineJoin = "round"; });
      if (g === "pokemon") {
        const fl = .55 + .25 * Math.sin(t * 7) * Math.sin(t * 3.3) + .1 * Math.random();
        const gr = x.createLinearGradient(0, h, 0, h * .45); gr.addColorStop(0, "rgba(255,90,40," + (.22 * fl * k) + ")"); gr.addColorStop(1, "rgba(255,68,56,0)");
        x.fillStyle = gr; x.fillRect(0, h * .45, w, h * .55);
        if (Math.random() < .55 * k * sp) s.p.push({ t: "ember", x: Math.random() * w, y: h + 4, vx: (Math.random() - .5) * .4, vy: -.7 - Math.random() * 1.6, life: 0, max: 120 + Math.random() * 140, r: .8 + Math.random() * 2.2, amb: 1 });
      }
      if (g === "riftbound") {
        if (Math.random() < .018 * k * sp) { const sx = w * (.05 + Math.random() * .5), sy = Math.random() * h * .5; const an = Math.random() * Math.PI; s.b.push(bolt(sx, sy, sx + Math.cos(an) * (90 + Math.random() * 200), sy + Math.sin(an) * (60 + Math.random() * 140), 0)); s.flash = Math.max(s.flash, .35); s.fx = sx; s.fy = sy; }
        if (Math.random() < .3 * k * sp) s.p.push({ t: "spark", x: Math.random() * w, y: Math.random() * h, vx: (Math.random() - .5) * 3, vy: (Math.random() - .5) * 3, life: 0, max: 8 + Math.random() * 10 });
      }
      if (g === "yugioh") {
        s.mist.forEach((m, i) => { const mx = w * (.15 + .7 * (.5 + .5 * Math.sin(t * .15 + m.s))), my = h * (.55 + .3 * Math.sin(t * .22 + m.s * 2)), r = 120 + 60 * Math.sin(t * .3 + i); const gr = x.createRadialGradient(mx, my, 0, mx, my, r); gr.addColorStop(0, "rgba(139,92,246," + (.09 * k) + ")"); gr.addColorStop(1, "rgba(139,92,246,0)"); x.fillStyle = gr; x.fillRect(mx - r, my - r, r * 2, r * 2); });
        if (Math.random() < .12 * k * sp) s.p.push({ t: "bub", x: Math.random() * w, y: h + 10, vy: -.35 - Math.random() * .8, wob: Math.random() * 6, life: 0, max: 200 + Math.random() * 200, r: 2 + Math.random() * 7 });
      }
      if (s.flash > .01) { const r = 260; const gr = x.createRadialGradient(s.fx, s.fy, 0, s.fx, s.fy, r); gr.addColorStop(0, "rgba(" + rgb + "," + (.45 * s.flash) + ")"); gr.addColorStop(1, "rgba(" + rgb + ",0)"); x.fillStyle = gr; x.fillRect(s.fx - r, s.fy - r, r * 2, r * 2); s.flash *= Math.pow(.9, sp); }
      // Elementos de ráfaga: cross-fade del canvas frontal al trasero en FRONT_MS.
      const paint = (it, fn) => {
        if (it.fr && fa > 0) { fx.globalAlpha = fa; fn(fx); x.globalAlpha = 1 - fa; fn(x); x.globalAlpha = 1; }
        else fn(x);
      };
      s.b = s.b.filter((b) => (b.life += sp) < b.max);
      s.b.forEach((b) => paint(b, (cx) => drawBolt(cx, b, 1.6)));
      s.p = s.p.filter((p) => (p.life += sp) < p.max);
      if (s.p.length > s.maxP) s.p.splice(0, s.p.length - s.maxP);
      s.p.forEach((p) => { step(p, s, sp); paint(p, (cx) => draw(cx, p)); });
      [x, fx].forEach((cx) => { cx.globalCompositeOperation = "source-over"; cx.globalAlpha = 1; });
    };
    const sync = () => {
      const run = visible && !document.hidden;
      if (run && !raf) raf = requestAnimationFrame(loop);
      if (!run && raf) { cancelAnimationFrame(raf); raf = 0; }
    };
    const io = new IntersectionObserver(([e]) => { visible = e.isIntersecting; sync(); });
    io.observe(c);
    document.addEventListener("visibilitychange", sync);
    sync();
    return () => { cancelAnimationFrame(raf); raf = 0; ro.disconnect(); io.disconnect(); document.removeEventListener("visibilitychange", sync); sysRef.current = null; };
  }, [reduce]);

  useEffect(() => {
    const changed = gameRef.current !== game;
    gameRef.current = game;
    const s = sysRef.current, c = backRef.current;
    if (!s || !c) { return undefined; }
    const fire = () => {
      const pill = burstFrom?.current;
      if (!pill) return;
      const a = pill.getBoundingClientRect(), b = c.getBoundingClientRect();
      const x = a.left + a.width / 2 - b.left, y = a.top + a.height / 2 - b.top;
      s.flash = 1; s.fx = x; s.fy = y; s.burstAt = performance.now();
      const n = Math.round(46 * Math.min(s.k, 1.4));
      for (let i = 0; i < n; i++) {
        const an = Math.random() * Math.PI * 2, sp = 1.5 + Math.random() * 5;
        if (game === "pokemon") s.p.push({ t: "ember", fr: 1, x, y, vx: Math.cos(an) * sp, vy: Math.sin(an) * sp - 1.5, life: 0, max: 40 + Math.random() * 40, r: 1 + Math.random() * 2.6 });
        if (game === "riftbound") s.p.push({ t: "spark", fr: 1, x, y, vx: Math.cos(an) * sp * 1.6, vy: Math.sin(an) * sp * 1.6, life: 0, max: 18 + Math.random() * 22 });
        if (game === "yugioh") s.p.push({ t: "drop", fr: 1, x, y, vx: Math.cos(an) * sp * .8, vy: Math.sin(an) * sp * .8 - 2, life: 0, max: 50 + Math.random() * 40, r: 1.5 + Math.random() * 3 });
      }
      if (game === "riftbound") for (let i = 0; i < 4; i++) { const an = Math.random() * Math.PI * 2, L = 120 + Math.random() * 180; s.b.push({ ...bolt(x, y, x + Math.cos(an) * L, y + Math.sin(an) * L * .6, 0), fr: 1 }); }
      if (game === "yugioh") for (let i = 0; i < 10; i++) s.p.push({ t: "bub", fr: 1, x: x + (Math.random() - .5) * 60, y, vy: -.6 - Math.random() * 1.2, wob: Math.random() * 6, life: 0, max: 80 + Math.random() * 60, r: 3 + Math.random() * 7 });
    };
    if (changed) { fire(); return undefined; }
    const tm = setTimeout(fire, 400);
    return () => clearTimeout(tm);
  }, [game, burstFrom]);

  if (reduce) return null;
  return (
    <>
      <canvas ref={backRef} aria-hidden data-testid="catalog-game-fx" className={`${CANVAS_CLS} z-0`} style={{ WebkitMaskImage: FX_MASK, maskImage: FX_MASK }} />
      <canvas ref={frontRef} aria-hidden data-testid="catalog-game-fx-front" className={`${CANVAS_CLS} z-[2]`} style={{ WebkitMaskImage: FX_MASK, maskImage: FX_MASK }} />
    </>
  );
};
